import React from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaInstagram,
  FaFacebookF,
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="bg-dark text-white mt-5">
      <div className="container py-5">

        <div className="row text-center text-md-start">

          {/* Company */}
          <div className="col-md-4 mb-4">
            <h4 className="fw-bold"  style={{ color: "#bb2124" }}>
              AK Crackers
            </h4>

            <p className="mb-0">
              Premium Quality Sivakasi Crackers for all festival
              celebrations. Wholesale & Retail available.
            </p>
          </div>

          {/* Address */}
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold mb-3">
              Contact Info
            </h5>

            <p>
              <FaMapMarkerAlt className="me-2 text-danger" />
              Sivakasi, Parapatti,
              Tamil Nadu, India
            </p>

            <p className="mb-1">
              <FaPhoneAlt className="me-2 text-success" />
              +91 99525 65684
            </p>

            <p>
              <FaPhoneAlt className="me-2 text-success" />
              +91 86808 68465
            </p>
          </div>

          {/* Social Media */}
          <div className="col-md-4 mb-4">
            <h5 className="fw-bold mb-3">
              Follow Us
            </h5>

            <a
              href="https://www.instagram.com/akcrackers_fireworks2026"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-light me-2 mb-2"
            >
              <FaInstagram className="me-2" />
              Instagram
            </a>

            <a
              href="https://www.facebook.com/profile.php?id=61590429791919"
              target="_blank"
              rel="noreferrer"
              className="btn btn-outline-light mb-2"
            >
              <FaFacebookF className="me-2" />
              Facebook
            </a>
          </div>

        </div>

        <hr className="border-secondary" />

        <div className="text-center">
          <small>
            © {new Date().getFullYear()} AK Crackers.
            All Rights Reserved.
          </small>
        </div>

      </div>
    </footer>
  );
};

export default Footer;